import { render, staticRenderFns } from "./promotionRules.vue?vue&type=template&id=769276fa&scoped=true&"
import script from "./promotionRules.vue?vue&type=script&lang=js&"
export * from "./promotionRules.vue?vue&type=script&lang=js&"
import style0 from "./promotionRules.vue?vue&type=style&index=0&id=769276fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769276fa",
  null
  
)

export default component.exports